export default __webpack_public_path__ + "static/media/UNMISS_POC_sites.7bc00b4f.jpg";